import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
export const cancelWaitingGiveawaysEndpoint = {
    [giveawayEndpointIds.GIVEAWAYS_CANCEL_EXPIRED_WAITING]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
        isLowSpec: true,
    },
};
